var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company--contacts-tab--details"},[_c('todo-tasks',{attrs:{"companyId":_vm.companyId,"contactId":_vm.contactId,"salesRep":_vm.company.salesPerson1UserId,"companyName":_vm.company.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }